import PermissionsOverview from '@/views/admin/permissions/PermissionsOverview.vue';

export default {
  path: 'permissions',
  name: 'PermissionsOverview',
  component: PermissionsOverview,
  meta: { menuItemName: 'PermissionsOverview' }
};
